"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const env_context_1 = require("./env-context");
const EnvProvider = ({ children, env }) => {
    return (0, jsx_runtime_1.jsx)(env_context_1.EnvContext.Provider, { value: env, children: children });
};
exports.EnvProvider = EnvProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52LXByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vudi1wcm92aWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLFlBQVksQ0FBQzs7OztBQUliLCtDQUEyQztBQVFwQyxNQUFNLFdBQVcsR0FBRyxDQUFDLEVBQUUsUUFBUSxFQUFFLEdBQUcsRUFBb0IsRUFBRSxFQUFFO0lBQ2pFLE9BQU8sdUJBQUMsd0JBQVUsQ0FBQyxRQUFRLElBQUMsS0FBSyxFQUFFLEdBQUcsWUFBRyxRQUFRLEdBQXVCLENBQUM7QUFDM0UsQ0FBQyxDQUFDO0FBRlcsUUFBQSxXQUFXLGVBRXRCIn0=